export default "__VITE_ASSET__DIxOqZ_0__"